'use client'

import type { ReactNode } from 'react'
import { PanelsSurfaceProvider, type PanelsSurface } from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { mainTemplateVariant, menuTemplateVariant } from '@/mailboxDesk/rowTemplates/RowTemplateConfig'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { PagingBar } from '@/msgComponents/controls/PagingBar/Legacy/PagingBar'
import { RefreshSubs } from '@/msgComponents/controls/RefreshSubs/Legacy/RefreshSubs'
import { CheckedsInfo } from '@/msgComponents/controls/CheckedsInfo/Modern/CheckedsInfo'
import { FoldSubsButton } from '@/msgComponents/controls/FoldSubsButton/Legacy/FoldSubsButton'
import { panelsSkin } from './PanelsSkin'

// Mailbox wiring for the shared panels skeleton: mailbox picks its Legacy control
// visuals and supplies its variant config and skin through the seam.

const mailboxPanelsSurface: PanelsSurface = {
  FoldSubsButton,
  PagingBar,
  RefreshSubs,
  CheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'This folder is empty',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: panelsSkin,
}

export function MailboxPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={mailboxPanelsSurface}>{children}</PanelsSurfaceProvider>
}
